
export default function TestimonialsSection() {
  const testimonials = [
    {
      name: '田中 美咲',
      age: '32歳',
      location: '渋谷区在住',
      image: 'https://public.readdy.ai/ai/img_res/44522ae2b3cb2e480e0f662038a15968.jpg',
      rating: 5,
      comment: '初めての不動産購入で不安でしたが、担当の方が親身になって相談に乗ってくださり、理想の物件を見つけることができました。アフターサポートも充実していて安心です。',
      propertyType: 'マンション購入'
    },
    {
      name: '佐藤 健太',
      age: '28歳',
      location: '新宿区在住',
      image: 'https://readdy.ai/api/search-image?query=Professional%20Japanese%20man%20in%20his%20late%2020s%2C%20business%20casual%20shirt%2C%20friendly%20smile%2C%20clean%20white%20background%2C%20portrait%20photography%2C%20confident%20expression%2C%20modern%20professional%20headshot&width=80&height=80&seq=customer2&orientation=squarish',
      rating: 5,
      comment: '転勤に伴う急な引越しでしたが、迅速に対応していただき、希望に合う賃貸物件をすぐに見つけてもらえました。地域の情報も詳しく教えていただき、とても助かりました。',
      propertyType: '賃貸契約'
    },
    {
      name: '山田 夫妻',
      age: '40代',
      location: '世田谷区在住',
      image: 'https://readdy.ai/api/search-image?query=Happy%20Japanese%20couple%20in%20their%2040s%2C%20casual%20attire%2C%20warm%20smiles%2C%20clean%20white%20background%2C%20portrait%20photography%2C%20family-oriented%2C%20professional%20headshot%20style&width=80&height=80&seq=customer3&orientation=squarish',
      rating: 5,
      comment: '子供の成長に合わせて一戸建てを探していました。学区や周辺環境まで考慮してご提案いただき、家族全員が満足できる住まいに出会えました。',
      propertyType: '一戸建て購入'
    }
  ];

  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            お客様の声
          </h2>
          <p className="text-lg text-gray-600">
            実際にご利用いただいたお客様からの声
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="bg-white rounded-2xl p-8 shadow-lg">
              <div className="flex items-center mb-6">
                <img
                  src={testimonial.image}
                  alt={testimonial.name}
                  className="w-16 h-16 rounded-full object-cover object-top mr-4"
                />
                <div>
                  <h4 className="font-semibold text-gray-900">
                    {testimonial.name}
                  </h4>
                  <p className="text-sm text-gray-600">
                    {testimonial.age} • {testimonial.location}
                  </p>
                </div>
              </div>

              <div className="flex mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-yellow-400"></i>
                ))}
              </div>

              <p className="text-gray-700 mb-4 leading-relaxed">
                {testimonial.comment}
              </p>

              <div className="border-t pt-4">
                <span className="inline-block px-3 py-1 bg-blue-50 text-blue-700 rounded-full text-sm">
                  {testimonial.propertyType}
                </span>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <p className="text-gray-600 mb-4">
            お客様満足度 <span className="text-2xl font-bold text-blue-600">98%</span>
          </p>
          <p className="text-sm text-gray-500">
            ※過去1年間の取引完了後アンケート結果より
          </p>
        </div>
      </div>
    </section>
  );
}
